function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.1726 10.98C12.265 13.0386 11.376 11.0544 9.84031 7.24901C8.5856 4.13987 3.88061 5.07261 2.62603 6.31627C0.772506 8.15367 0.164671 13.8435 2.62603 17.1983C5.13532 20.6183 7.95832 17.8201 7.95832 21.862C7.95832 24.0384 -0.510648 28.3912 4.82167 34.9205C10.154 41.4497 14.2316 28.3912 18.6229 27.4585C23.0142 26.5257 15.8 43.1127 27.4056 38.0296C40.8932 32.1222 27.5388 27.1049 29.6012 24.0384C30.8559 22.1729 42.2149 26.1542 40.8932 19.9965C37.7565 5.38349 27.4056 14.0891 26.1509 14.0891C24.6539 14.0891 23.3279 11.1665 24.5826 8.18173C26.1509 4.45073 27.4056 1.65252 19.5639 1.03069C11.7223 0.408858 17.3683 9.42542 15.1726 10.98Z",
  stroke: "black"
});

var SvgBlob = function SvgBlob(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlob, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blob.3828cde4.svg";
export { ForwardRef as ReactComponent };